<template>
  <div class="usermanager">
    <navbar></navbar>
    <b-container style="height: 80vh;">
      <b-row style="height: 80%;">
          <b-col id="list-user">
            <h2>LISTA UTENTI REGISTRATI</h2>
            <scrolly id="list">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in users" :key="index">
                  <b-list-group-item v-if="index%2 == 0" v-on:click="modalUserOpen(value)">{{value.nome}} {{value.cognome}}</b-list-group-item>
                  <b-list-group-item variant="secondary" v-else v-on:click="modalUserOpen(value)">{{value.nome}} {{value.cognome}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
          <b-col id="add-user">
            <h2>AGGIUNGI NUOVO UTENTE</h2>
            <br>
            <b-form v-on:submit.prevent="addUser">
              <b-input-group prepend="Nome">
                <b-form-input v-model="add.nome"></b-form-input>
              </b-input-group>
              <br>
              <b-input-group prepend="Cognome">
                <b-form-input v-model="add.cognome"></b-form-input>
              </b-input-group>
              <br>
              <b-input-group prepend="E-mail">
                <b-form-input type="email" v-model="add.email" :state="emailState"></b-form-input>
              </b-input-group>
              <br>
              <b-input-group prepend="Password">
                <b-form-input v-model="add.password"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="outline-info" v-on:click="generate">Genera</b-btn>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-input-group prepend="Zona">
                <b-form-select multiple :select-size="4" v-model="add.zona" :options="zone"  value-field="id" text-field="nome"></b-form-select>
              </b-input-group>
              <br>
              <b-button type="submit" variant="success">Aggiungi utente</b-button>
            </b-form>
          </b-col>
      </b-row>
  </b-container>
  <b-modal v-model="modal.user" title="Dettagli utente">
    <div>
      <b-input-group prepend="Nome">
        <b-form-input v-model="modaldata.nome" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Cognome">
        <b-form-input v-model="modaldata.cognome" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="E-mail">
        <b-form-input type="email" v-model="modaldata.email" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Zona">
        <b-form-select multiple :select-size="4" v-model="modaldata.zona" :options="zone" value-field="id" text-field="nome"></b-form-select>
      </b-input-group>
      <br>
    </div>

    <div slot="modal-footer" class="w-100" v-if="!modal.userdelete">
      <b-container>
        <b-row>
          <b-col><b-button variant="danger" size="sm" v-on:click="modal.userdelete = true">Elimina</b-button></b-col>
          <b-col></b-col>
          <b-col>
            <b-button-group>
              <b-button variant="success" style="float: left;" v-on:click="changeUser()">Salva</b-button>
              <b-button variant="secondary" style="float: right;" v-on:click="modal.user = false">Chiudi</b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div slot="modal-footer" class="w-100" v-else>
      <p style="float: left;">Si sta eliminando questo utente, proseguire?</p>
      <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.userdelete = false">No</b-button>
      <b-button variant="danger" style="float: right;" v-on:click="deleteUser(modaldata.id)">Si</b-button>
    </div>
  </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly'

export default {
  name: 'usermanager',
  components: {
    navbar,
    Scrolly,
    ScrollyViewport,
    ScrollyBar
  },
  data() {
    return {
      users: [],
      zone: [],
      add: {
        nome: "",
        cognome: "",
        email: "",
        password: "",
        zona: []
      },
      modal: {
        user: false,
        userdelete: false
      },
      modaldata: {
        nome: "",
        cognome: "",
        email: "",
        zona: []
      },
      emailState: null
    }
  },
  created: function(){
        this.updateUser()
        this.updateZone()
  },
  methods: {
    addUser() {
      if(this.add.nome != "" && this.add.cognome != "" && this.add.email != "" && this.add.password != "" && this.add.zona.length > 0){
        Vue.http.post(this.$hostlink+'user/add', this.add, {credentials : true}).then(response => {
          if(response.body.success){
            this.emailState = null
            this.add.nome = ""
            this.add.cognome = ""
            this.add.email = ""
            this.add.password = ""
            this.add.zona = []
            this.updateUser()
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Utente inserito con successo!',
              type: 'success'
            })
          }else{
            this.emailState = false
            Vue.notify({
              group: 'global',
              title: 'Errore durante la creazione!',
              text: response.body.msg,
              type: 'error'
            })
          }
        }, response => {
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: 'Errore di comunicazione con i server!',
            type: 'error'
          })
        })
      }else{
        Vue.notify({
          group: 'global',
          title: 'Dati utente non corretti',
          text: 'Assicurati di aver inserito i dati dell\'utente correttamente!',
          type: 'error'
        })
      }
    },
    updateUser(){
      Vue.http.post(this.$hostlink+'user/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.users = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    deleteUser(id){
      Vue.http.post(this.$hostlink+'user/delete', {id: id}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Utente eliminato con successo!',
            type: 'success'
          })
        }else
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante l\'eliminazione dell\'utente. Verificare se non è stato precedentemente eliminato!',
            type: 'error'
          })
        this.modal.user = false
        this.updateUser()
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore durante la comunicazione con il server!',
          type: 'error'
        })
      })
    },
    updateZone(){
      Vue.http.post(this.$hostlink+'zona/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.zone = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    randomPassword(length) {
      var chars = "abcdefghijklmnopqrstuvwxyz-_ABCDEFGHIJKLMNOP1234567890"
      var pass = ""
      for (var x = 0; x < length; x++) {
          var i = Math.floor(Math.random() * chars.length)
          pass += chars.charAt(i)
      }
      return pass
    },
    generate() {
         this.add.password= this.randomPassword(12)
    },
    modalUserOpen(user){
      this.modaldata = user
      this.modal.userdelete = false
      this.modal.user = true

      Vue.http.post(this.$hostlink+'user/userlistzone', {id: user.id}, {credentials : true}).then(response => {
        if(response.body.success){
          this.modaldata.zona = response.body.data
          console.log(this.modaldata.zona)
        }
      }, response => {
          // error callback
      })
    },
    changeUser(){
      Vue.http.post(this.$hostlink+'user/update', this.modaldata, {credentials : true}).then(response => {
        if(response.body.success){
          this.modal.userdelete = false
          this.modal.user = false

          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Utente aggiornato con successo!',
            type: 'success'
          })
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante l\'aggiornamento dell\'utente!',
            type: 'error'
          })
        }
      }, response => {
          // error callback
      })
    }
  }
}
</script>

<style>
#list-user{
  margin-top: 10%;
}

#list{
  height: 100%;
}

#add-user{
  margin-top: 10%;
  height: 100%;
}
</style>
